<template>
  <div class="login-moudle" v-loading="editloading">
    <div class="title">修改密码</div>
    <div class="box">
      <div class="item d-flex a-center">
        <input v-model="mobile" disabled placeholder="请输入手机号" />
      </div>
      <div class="item d-flex a-center">
        <input type="text" v-model="code" placeholder="请输入验证码" style="padding-right: 0;" />
        <button class="common-btn" :style="{ background: get_code_back_color }" @click="huoquphonecode">{{get_code_text}}</button>
      </div>
      <div class="item d-flex a-center">
        <input type="password" v-model="pwd" placeholder="新密码" />
      </div>
      <div class="item d-flex a-center">
        <input type="password" v-model="pwd1" placeholder="确认新密码" />
      </div>
      <button class="mix-btn" v-loading="loginLoading" @click="confirm">确认</button>
    </div>
    <div class="imgcode d-flex j-center a-center" v-if="showImgCode">
      <div class="imgcodecontent">
        <div class="imgcodetitle">请输入图形验证码</div>
        <div class="input input1 d-flex a-center">
          <input v-model="verifyCode1" maxlength="6" placeholder="输入验证码" />
          <img class="iiimg" v-loading="loading" @click="getImgCode" :src="imgCode1" />
        </div>
        <div class="imgcodebtn d-flex a-center j-center">
          <div class="qx" @click="showImgCode = false">取消</div>
          <div class="qd" @click="getPhoneCode">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      mobile: this.$store.state.loginPhone,
      pwd: '',
      pwd1: '',
      verifyCode1: '',
      code: '',
      code_id: '',
      imgcode1: '',
      loading: false,
      loginLoading: false,
      showImgCode: false,
      smsid: '',
      get_code_text: "发送验证码",
      get_code_is_waiting: false,
      get_code_back_color: "#E10019",
      Timer: null,
      editloading: false
    }
  },
  created() {
    this.getImgCode()
    this.loading = false
  },
  methods: {
    getImgCode() {
      this.loading = true
      this.$api.login.captcha().then((res) => {
        this.loading = false
        if (res.code === 'SUCCESS') {
          this.code_id = res.data.id
          this.imgCode1 = this.$utils.baseURL + res.data.captcha_image
        }
      })
    },
    huoquphonecode() {
      if (!this.mobile) {
        this.$message.warning("请输入手机号")
      } else if (this.mobile.length != 11) {
        this.$message.warning("手机号码为11位数字")
      } else {
        this.showImgCode = true
        this.getImgCode()
      }
    },
    getPhoneCode() {
      if (this.get_code_is_waiting) {
        return;
      }
      if (!this.verifyCode1) {
        this.$message.warning('请输入图形验证码！')
      } else {
        this.get_code_text = "发送中...";
        this.$api.login.request_sms_code({
          captcha: this.verifyCode1,
          captcha_session_id: this.code_id,
          phone_number: this.mobile
        }).then((res) => {
          if (res.code == 'SUCCESS') {
            this.get_code_is_waiting = true;
						this.get_code_back_color = "#B7BECC";
            this.setTimer()
            this.smsid = res.data.id
          } else {
            var msg = res.message
            if ('手机号码尚未注册' == msg) {
              msg = '手机号码不存在，请联系单位联络员在陕西干部教育培训管理系统里核对手机号码！'
            }
            this.$message.warning('warning', msg)
          }
          this.showImgCode = false
        })
      }
    },
    setTimer() {
      let holdTime = 60;
      this.get_code_text = "重新获取(60s)";
      this.Timer = setInterval(() => {
        if (holdTime <= 0) {
          this.get_code_is_waiting = false;
          this.get_code_text = "获取验证码";
          this.get_code_back_color = "#E10019";
          clearInterval(this.Timer);
          return;
        }
        this.get_code_text = "重新获取(" + holdTime + "s)";
        holdTime--;
      }, 1000);
    },
    confirm() {
      let zz = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&,.])[A-Za-z\d$@$!%*#?&,.]{8,}$/
      if(!this.smsid){
        this.$message.warning('请获取手机验证码')
      }else if(!this.code){
        this.$message.warning('请输入手机验证码')
      }else if(!this.pwd){
        this.$message.warning('请输入新密码')
      }else if(!this.pwd1){
        this.$message.warning('请确认新密码')
      }else if(this.pwd != this.pwd1){
        this.$message.warning('两次密码输入不一致')
      }else if(!zz.test(this.pwd)){ //判断密码是否符合正则标准
        this.$message.warning('密码至少需要8位，同时包含字母、数字和特殊符号($@$!%*#?&,.)')
      }else{
        this.editloading = true
        this.$api.login.modify_password({
          captcha: this.code,
          captcha_session_id: this.smsid,
          mobile: this.mobile,
          password: this.pwd
        }).then((res)=>{
          if(res.code == 'SUCCESS'){
            this.$api.login.updatePersonPassword({
              newPassword: this.pwd,
              mobilePhone: this.mobile
            }).then((res2) =>{
              if(res2.res == 1){
                this.$store.commit('setChangePassword', false)
                this.$message.success('密码修改成功！')
              }
            })
          }else{
            this.$message.warning(res.message)
          }
          this.editloading = false
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.login-moudle{
  width: 315px;
  background: #fff;
  position: relative;
  .title{
    color: #E10019;
  }
  .box{
    padding: 25px 20px;
    .item{
      width: 100%;
      height: 40px;
      border-radius: 5px;
      overflow: hidden;
      margin-bottom: 25px;
      background: #e0e0e0;
      .icon{
        background: #E10019;
        width: 44px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
          width: 15px;
        }
      }
      input{
        flex: 1;
        height: 40px;
        padding: 0 15px;
        background: #e0e0e0;
      }
      .verify-code{
        width: 90px;
        height: 40px;
        margin-left: 15px;
      }
      .common-btn{
        height: 30px;
        width: 100px;
        margin-right: 10px;
        font-size: 14px;
      }
    }
  }
  .imgcode {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    .qx {
      background: #f1f1f1;
      margin-right: 0.9375rem;
    }
    .qd {
      background: #E10019;
      color: #FFFFFF;
    }
    .imgcodecontent {
      background: #FFFFFF;
      padding: 0.9375rem;
      border-radius: 0.3125rem;
      width: 14.375rem;
    }
    .imgcodetitle {
      font-size: 1rem;
      color: #E10019;
    }
    .input1 {
      margin-top: 1.25rem;
    }
    .input1 input {
      width: 50%;
      height: 1.875rem;
      border: 1px solid #cccccc;
      box-sizing: border-box;
      font-size: 0.875rem;
      border-radius: 0.3125rem;
      outline: none;
      padding: 0 0.625rem;
    }
    .input1 img {
      display: block;
      width: calc(50% - 10px);
      margin-left: 10px;
    }
    .imgcodebtn {
      margin-top: 1.25rem;
      div {
        font-size: 0.75rem;
        padding: 0.3125rem 0.9375rem;
        border-radius: 0.3125rem;
        cursor: pointer;
      }
    }
  }
}
</style>
